import {fetchAndDeserialize} from '../../../util/api-adapter';
import {objectToUrlParameters} from '../../../util/url';
import {ReviewsAndAnswersFilterStateType} from '../filter/reviews-and-answers-statistics-filter-type';
import {reviewsAndAnswersApiFilterValues} from '../filter/reviews-and-answers-statistics-helper';

import {
    averageResponseTimeByEmployeeItemSchema,
    AverageResponseTimeByEmployeeType,
} from './average-response-time-by-employee-type';

export function fetchAverageResponseTimeByEmployee(
    filter: ReviewsAndAnswersFilterStateType,
    mainFilterKey: string
): Promise<Array<AverageResponseTimeByEmployeeType>> {
    return fetchAndDeserialize(
        `/cp/reviews/statistics/employees/?${objectToUrlParameters(
            reviewsAndAnswersApiFilterValues(filter, mainFilterKey)
        )}`,
        averageResponseTimeByEmployeeItemSchema.array()
    );
}
